/* eslint-disable no-param-reassign */

import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import listSaga from './list';
import byIdSaga from './byId';
import statisticSaga from './statistic';
import { BaseState, createCRUDModel, createCRUDStates } from '../creator';
import { RootState } from '../index';
import { PaginatedResponse } from '../types';
import { Country } from '../country';

export const moduleName = 'international';

export interface International {
  id: string;
  isActive: boolean;
  description: string;
  country: Country;
  userCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface Statistic {
  id: number;
  countryName: string;
  medianPercentValue: string;
  zeroPercentValue: string;
}
export interface State {
  list: BaseState<PaginatedResponse<International>>;
  byId: BaseState<International>;
  statistic: BaseState<Statistic[]>;
}

const models = ['list', 'byId', 'statistic'];

export const defaultState: State = createCRUDStates<State>(models);

export const international = createSlice({
  name: moduleName,
  initialState: defaultState,
  reducers: createCRUDModel(models, moduleName),
});

export const { actions } = international;

export function useInternational(): State {
  return useSelector((state: RootState) => state[moduleName]);
}

export function* saga() {
  yield* listSaga();
  yield* byIdSaga();
  yield* statisticSaga();
}
